import React, { Component, ReactNode } from 'react'
import { Translate } from 'react-localize-redux'
import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { ICheckboxFieldProps } from './Fields.interfaces'
import styles from './Fields.module.scss'
import { Tooltip } from '@digicert/dcone-common-ui'
import { translate } from 'shared/helpers/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons'

export default class CheckboxField extends Component<ICheckboxFieldProps, any> {
  constructor (props) {
    super(props)
    this.state = {
      visible: false,
      infoTooltip: false
    }
  }
  public render (): ReactNode {
    const { label, input, disabled, useLabelWithoutTranslation, meta: { touched, error }, infoSection, licensePerm } = this.props
    const { visible, infoTooltip } = this.state
    return (
      <div className={styles.checkboxWrap}>
        <Checkbox
          disabled={disabled || licensePerm}
          checked={Boolean(input.value)}
          onChange={this.handleChange}
        />

        {label &&
          <label className={styles.checkboxLabel} onMouseOver={() => {
              if(licensePerm) {
                this.setState({visible:!visible})
              }
            }}
            onMouseLeave={() => {
              this.setState({visible:false})
            }}>
            {useLabelWithoutTranslation ? <span>{label}</span> : <Translate id={label} />}
            {infoSection &&
            <a href="#"
              onMouseOver={() => {this.setState({infoTooltip:!infoTooltip})}}
              onMouseLeave={() => {this.setState({infoTooltip:false})}}>
              <FontAwesomeIcon size='1x' icon={faQuestionCircle} color='#0174C3'
                className={styles.questionMark}
              />
              <Tooltip
                placement="right"
                title={translate('manageUser.administrators.form.infoTooltipText') as string}
                visible={infoTooltip}
              />
            </a>  
            }
            
            {licensePerm !== undefined && licensePerm && 
              <Tooltip
                placement="right"
                title={translate('manageUser.administrators.form.disabledTooltipText') as string}
                visible={visible}
              />  
            }
            
          </label>
        }
        {touched && (error &&
          <label className={styles.errorLabel}><Translate id={error} /></label>
        )}
      </div>
    )
  }

  private handleChange = (event: CheckboxChangeEvent): void => {
    this.props.input.onChange(event.target.checked)
  }
}
